import { render, staticRenderFns } from "./PurchaseReq.vue?vue&type=template&id=6a4e80a3&scoped=true&"
import script from "./PurchaseReq.vue?vue&type=script&lang=js&"
export * from "./PurchaseReq.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseReq.vue?vue&type=style&index=0&id=6a4e80a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4e80a3",
  null
  
)

export default component.exports